import { useLocation } from "react-router-dom";
import { urls } from "../../../urls";

export const useIsV2 = (): boolean => {
  const { pathname } = useLocation();
  return pathname === urls.v2.home || pathname.startsWith(`${urls.v2.home}/`);
};
